exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PasswordForm__forgotten___1wW2n {\n  margin-top: 12px;\n}\n", ""]);

// exports
exports.locals = {
	"forgotten": "PasswordForm__forgotten___1wW2n"
};